import "./PublicationSearchPageFilters.scss";
import { Button, DropdownHierarchy } from "/App.Components";
import { DropdownHierarchyProps, DropdownItemProps } from "/App.GeneratedTypes";
import { createSpreadableBem } from "../../../Helpers/createBem";
import { DesignTheme } from "../../../App.GeneratedEnums";

export interface Props {
  areaDropdown?: DropdownHierarchyProps;
  themeDropdown?: DropdownHierarchyProps;
  yearDropdown?: DropdownHierarchyProps;
  typeDropdown?: DropdownHierarchyProps;
  selectedArea?: DropdownItemProps;
  setSelectedArea?: (area?: DropdownItemProps) => void;
  selectedTheme?: DropdownItemProps;
  setSelectedTheme?: (theme?: DropdownItemProps) => void;
  selectedYear?: DropdownItemProps;
  setSelectedYear?: (year?: DropdownItemProps) => void;
  selectedType?: DropdownItemProps;
  setSelectedType?: (type?: DropdownItemProps) => void;
  // Optional for callers whose setters already run the search.
  applyFilters?: () => void;
  filterSelectedAriaLiveSuffix?: string;
  clearAllFilters: () => void;
  clearAllFiltersText: string;
  theme?: DesignTheme;
}

const PublicationSearchPageFilters = ({
  areaDropdown,
  themeDropdown,
  yearDropdown,
  typeDropdown,
  selectedArea,
  selectedTheme,
  selectedYear,
  selectedType,
  setSelectedArea,
  setSelectedTheme,
  setSelectedYear,
  setSelectedType,
  applyFilters,
  filterSelectedAriaLiveSuffix,
  clearAllFilters,
  clearAllFiltersText,
  theme,
}: Props) => {
  const bem = createSpreadableBem("publication-search-page-filters-norad");
  return (
    <div {...bem("")}>
      {themeDropdown && (
        <DropdownHierarchy
          {...themeDropdown}
          selected={selectedTheme}
          setSelected={(theme?: DropdownItemProps) => {
            setSelectedTheme && setSelectedTheme(theme);
            applyFilters?.();
          }}
          filterSelectedAriaLiveSuffix={filterSelectedAriaLiveSuffix}
          theme={theme}
        />
      )}
      {areaDropdown && (
        <DropdownHierarchy
          {...areaDropdown}
          selected={selectedArea}
          setSelected={(area?: DropdownItemProps) => {
            setSelectedArea && setSelectedArea(area);
            applyFilters?.();
          }}
          filterSelectedAriaLiveSuffix={filterSelectedAriaLiveSuffix}
          theme={theme}
        />
      )}
      {yearDropdown && (
        <DropdownHierarchy
          {...yearDropdown}
          selected={selectedYear}
          setSelected={(year: DropdownItemProps) => {
            setSelectedYear && setSelectedYear(year);
            applyFilters?.();
          }}
          filterSelectedAriaLiveSuffix={filterSelectedAriaLiveSuffix}
          theme={theme}
        />
      )}
      {typeDropdown && (
        <DropdownHierarchy
          {...typeDropdown}
          selected={selectedType}
          setSelected={(type?: DropdownItemProps) => {
            setSelectedType && setSelectedType(type);
            applyFilters?.();
          }}
          filterSelectedAriaLiveSuffix={filterSelectedAriaLiveSuffix}
          theme={theme}
        />
      )}
      {(selectedArea || selectedTheme || selectedType || selectedYear) && (
        <div>
          <Button
            style={
              theme === DesignTheme.Insight
                ? "insight-secondary"
                : "secondary"
            }
            size="s"
            label={clearAllFiltersText}
            onClick={clearAllFilters}
          />
        </div>
      )}
    </div>
  );
};

export default PublicationSearchPageFilters;
